// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/power-altitude-humidity.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/power-altitude-humidity/power-altitude-humidity.js';

mount([g0]);
